/**
 * מעבד שגיאת API (מ-RTK Query) למחרוזת קריאה למשתמש,
 * כולל פירוט שדות ספציפיים אם השרת החזיר errors לפי שדה (status 422).
 */
export function formatApiError(e: any): string {
    const data = e?.data;
    if (data?.errors && typeof data.errors === 'object') {
        const parts = Object.entries(data.errors).map(([field, messages]) => {
            const text = Array.isArray(messages) ? messages.join(', ') : String(messages);
            return `${field}: ${text}`;
        });
        if (parts.length) return parts.join(' | ');
    }
    return data?.msg || e?.message || 'שגיאה לא ידועה';
}

